export default __webpack_public_path__ + "static/media/footer-logo.3dba7c44.svg";